// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { difference } from 'lodash';

// Actions
import { channelsUpdated } from '../socket/socketActions';

// Selectors
import socketChannelSelector from './socketChannelSelector';

const mapDispatchToProps = (dispatch) => ({
    dispatchChannelsUpdated: (channelUpdate) => dispatch(channelsUpdated(channelUpdate)),
});

@connect(socketChannelSelector, mapDispatchToProps)
class SocketChannelManager extends React.Component {
    componentWillMount() {
        const { channels, boardChannels } = this.props;
        this.updateChannels({ nextChannels: channels, boardChannels });
    }

    componentWillReceiveProps(nextProps) {
        const { channels, boardChannels } = nextProps;

        if (channels !== this.props.channels) {
            this.updateChannels({ nextChannels: channels, prevChannels: this.props.channels, boardChannels });
        }
    }

    updateChannels = ({ nextChannels, prevChannels = [], boardChannels }) => {
        const { dispatchChannelsUpdated } = this.props;

        const joined = difference(nextChannels, prevChannels);
        const left = difference(prevChannels, nextChannels);

        // Don't update if we haven't joined or left anything
        if (!joined.length && !left.length) return;

        dispatchChannelsUpdated({
            joined,
            left,
            boardChannels,
        });
    };

    render() {
        return null;
    }
}

SocketChannelManager.propTypes = {
    channels: PropTypes.array,
    boardChannels: PropTypes.array,
    dispatchChannelsUpdated: PropTypes.func,
};

export default SocketChannelManager;
